import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-left no-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_q_toggle, {
        modelValue: _ctx.element.Positive,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.element.Positive) = $event)),
        "checked-icon": "add",
        color: "navy",
        label: "",
        size: "xs",
        "unchecked-icon": "remove"
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", {
        class: _normalizeClass(['q-my-none', 'q-pt-xs', { 'text-grey-8': !_ctx.element.Entity }])
      }, _toDisplayString(_ctx.getElementName), 3)
    ]),
    _createVNode(_component_q_btn, {
      class: "q-px-none q-mx-none q-mt-xs unset-items-center",
      flat: "",
      dense: "",
      "aria-label": _ctx.$t('delete_filter'),
      icon: "close",
      size: "sm",
      tabindex: "-1",
      color: "accent",
      onClick: _ctx.deleteItem
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_tooltip, {
          delay: 300,
          anchor: "top middle",
          self: "center middle"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("remove")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["aria-label", "onClick"])
  ], 64))
}